import { environments } from '../config/configManager';
import { createHttpClient } from './create-http-client';

function getAuthHeaders() {
	try {
		const userRaw = localStorage.getItem("user");
		if (userRaw) {
			const user = JSON.parse(userRaw);
			if (user.idToken) return { Authorization: user.idToken };
		} else {
			const token = localStorage.getItem("token");
			if (token) return { Authorization: token };
		}
	} catch (error) {
		console.log(error);
	}
	return {};
}

function getBearerAuthHeaders() {
	try {
		const userRaw = localStorage.getItem("user");
		if (userRaw) {
			const user = JSON.parse(userRaw);
			if (user.idToken) return { Authorization: `Bearer ${user.idToken}` };
		} else {
			const token = localStorage.getItem("token");
			if (token) return { Authorization: `Bearer ${token}` };
		}
	} catch (error) {
		console.log(error);
	}
	return {};
}

const httpModel = createHttpClient({
	baseURL: 'https://prd-lif-banners.s3.amazonaws.com/',
});

const lifHttp = createHttpClient({
	baseURL: environments.lif,
	timeout: 120000,
	getAuthHeaders,
});

const lifUser = createHttpClient({
	baseURL: environments.lif,
	timeout: 120000,
});

const vcpodeHttp = createHttpClient({
	baseURL: environments.vcpode,
	timeout: 120000,
	getAuthHeaders,
});

const vcpodeBearer = createHttpClient({
	baseURL: environments.vcpode,
	timeout: 120000,
	getAuthHeaders: getBearerAuthHeaders,
});

async function refreshToken() {
	try {
		var user = JSON.parse(localStorage.getItem("user"));

		const { data } = await lifHttp.put(`auth/token`, {
			username: user.user.username,
			token: user.refreshToken
		}, {
			headers: {
				'Authorization': user.idToken,
				'Content-Type': 'application/json'
			}
		});
		user.idToken = data.idToken;
		user.refreshToken = data.refreshToken;
		user.expires = data.expires;
		localStorage.setItem("user", JSON.stringify(user));
		console.log("Token renovado com sucesso");
	} catch (error) {
		console.log("Erro ao renovar o token", error);
		window.location.href = "/";
	}
}

function tokenObserver() {
	setInterval(() => {
		try {
			const user = JSON.parse(localStorage.getItem("user"));
			if (user && user.expires) {
				const nowTime = Math.floor(Date.now() / 1000);
				const expiration = user.expires - nowTime;
				console.log('tentou renovar o token', expiration);

				if (expiration < 300) {
					refreshToken();
				}
			}
		} catch (error) {
			console.error("Erro ao acessar o localStorage", error);
		}
	}, 12000);
}

try {
	if (localStorage.getItem("user")) {
		tokenObserver();
	}
} catch (error) {
	console.error("Erro ao acessar o localStorage", error);
}

export {
	httpModel,
	lifHttp,
	lifUser,
	vcpodeBearer,
	vcpodeHttp
};

